import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@uhg-abyss/web/tools/styled';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { event as adobeTaggingEvent } from '@uhg-abyss/web/tools/event';
import { LagoonContext } from '@src/AppContext/LagoonContext';

const ProviderLink = styled('a', {
  color: '$info1',
  '&:hover': {
    cursor: 'pointer',
    textDecoration: 'none',
    color: '$info1',
  },
  '&:focus': {
    outline: 'none',
    color: '$info1',
    boxShadow: 'none',
  },
});
export const UHCProviderLink = ({ style }) => {
  const lagoonContext = React.useContext(LagoonContext);
  const featureToggles = lagoonContext.getTable('feature-toggles');
  const handleAdobe = () => {
    if (featureToggles.getRow('ADOBE_ANALYTICS_TRACKING')?.active) {
      adobeTaggingEvent('EXIT_CLICK', {
        exitLink: 'Return to UHCProvider.com',
      });
    }
  };
  return (
    <ProviderLink
      style={{ ...style }}
      href="https://www.uhcprovider.com"
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleAdobe}
    >
      <strong>Return to UHCProvider.com</strong> &nbsp;
      <IconSymbol icon="arrow_forward" size={16} color="$primary1" />
    </ProviderLink>
  );
};

UHCProviderLink.propTypes = {
  style: PropTypes.shape({}),
};

UHCProviderLink.defaultProps = {
  style: null,
};
